import { useState, useCallback } from 'react';
import JSCookie from 'js-cookie';
/* globals gtag: true */

const consent = [
    {
        id: 'functionality_storage',
        label: 'Fonctionnel',
        description: 'Témoins requis pour le bon fonctionnement du site',
        value: true,
        disabled: true,
    },
    {
        id: 'analytics_storage',
        label: 'Statistiques',
        description:
            'Témoins utilisés pour mesurer le comportement des utilisateurs sur le site (Google Analytics)',
        value: false,
    },
    // {
    //     id: 'ad_storage',
    //     label: 'Publicité',
    //     description: 'Témoins utilisés pour le ciblage publicitaire (Google Ads, Facebook)',
    //     value: false,
    // },
    // {
    //     id: 'personalization_storage',
    //     label: 'Publicité culturelle',
    //     description:
    //         'Témoins utilisés pour le ciblage publicitaire de nos partenaires culturels locaux (Data Coop)',
    //     value: false,
    // },
    // {
    //     id: 'show_widgets',
    //     label: 'Intégrations tierces',
    //     description:
    //         'Intégrations externes (iframe) et lecteurs médias utilisés par notre site (Google Maps, Spotify).',
    //     value: false,
    // },
];

const useConsent = ({ onClose }) => {
    const [choices, setChoices] = useState(
        (consent || []).map((it) => ({
            ...it,
            value:
                // eslint-disable-next-line no-nested-ternary
                JSCookie.get(it.id) === 'granted'
                    ? true
                    : JSCookie.get(it.id) === 'denied'
                    ? false
                    : it.value,
        })),
    );

    const onSubmit = useCallback((values) => {
        const gtagItems = (values || []).reduce((acc, { id = null, value = false }) => {
            if (id !== null) {
                const nextValue = value ? 'granted' : 'denied';
                JSCookie.set(`${id}`, nextValue, { secure: true, expires: 60 });
                if (id.match(/_storage$/)) {
                    return { ...acc, [id]: nextValue };
                }
                return acc;
            }
            return acc;
        }, {});

        if (typeof gtag !== 'undefined') {
            // eslint-disable-next-line no-console
            console.log('consent', gtag, gtagItems);
            gtag('consent', 'update', gtagItems);
        }

        JSCookie.set('popup_cookies', false, { secure: true, expires: 182 });

        if (onClose !== null) {
            onClose(values || []);
        }
    }, []);

    const onClickChoice = useCallback(
        (id, newValue) => {
            setChoices(
                (choices || []).reduce((acc, it) => {
                    if (it.id === id) {
                        return [...acc, { ...it, value: newValue }];
                    }
                    return [...acc, it];
                }, []),
            );
        },
        [choices, setChoices],
    );

    const onClickConfirm = useCallback(() => {
        onSubmit(choices);
    }, [choices]);

    const onClickAccept = useCallback(() => {
        const items = consent.map((it) => ({ ...it, value: !it.disabled ? true : it.value }));
        setChoices(items);
        onSubmit(items);
    }, [consent, onSubmit]);

    const onClickDeny = useCallback(() => {
        const items = consent.map((it) => ({ ...it, value: !it.disabled ? false : it.value }));
        setChoices(items);
        onSubmit(items);
    }, [consent, onSubmit]);

    return {
        choices,
        onClickChoice,
        onClickConfirm,
        onClickAccept,
        onClickDeny,
    };
};

export default useConsent;
